import LocationPill from './LocationPill';

export default LocationPill;
